import React, { useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function InfoCompany() {
    const navigate = useNavigate();
    //define state
    const [company, setCompany] = useState([]);

    //function "fetchData"
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/infoCompany/readInfoCompany`
            );
            const data = await response.data;

            setCompany(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    React.useEffect(() => {
        //panggil method "fetchData"
        fetchData();
    }, []);

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Make axios delete request
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/infoCompany/deleteInfoCompany/${id}`
                    );
                    // Refetch data after successful delete
                    fetchData();

                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Cover Foto",
            selector: (row) => {
                console.log("Foto row:", row.foto);
                return (
                    <img
                        src={`${process.env.REACT_APP_API_URL}/uploads/${row.foto}`}
                        alt="cover"
                        style={{ width: "100px", height: "70px" }}
                    />
                );
            },

            sortable: true,
        },
        {
            name: "Deskripsi",
            selector: (row) => row.deskripsi,
            sortable: true,
            width: "450px",
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={"/sekilas-perusahaanEdit/" + row.id} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button onClick={() => handleDelete(row.id)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
            width: "150px",
        },
    ];
    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Info Company</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Info Company</h3>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body">
                                        {company.length === 0 && (
                                            <Link
                                                to="/sekilas-perusahaanAdd"
                                                className="btn btn-primary"
                                            >
                                                <i className="nav-icon fas fa-plus mr-2" />
                                                Add Data
                                            </Link>
                                        )}
                                        <DataTable columns={columns} data={company} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default InfoCompany;
